// src/components/InvalidOtpModal.js
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  CircularProgress
} from "@mui/material";
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import { useTheme } from "@mui/material/styles";
import warning from "../../../assets/warning.svg";
import { BASE_URL } from "../../../components/BaseUrl";
import { toast } from "react-hot-toast";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useLocation,useNavigate } from "react-router-dom";
const InvalidOtpModal = ({ open, onClose,email,message  }) => {
  const { t } = useTranslation();

    const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
console.log(email)
  const handleResendOtp = async () => {
    if (!email) {
      toast.error("Email is missing!");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/company-admins/resend-verification-otp`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }), // ✅ send email
        }
      );

      const data = await response.json();

      if (response.ok) {
        toast.success(data.message || "OTP Resent Successfully!");
        setTimeout(() => {
        //   navigate("/otp-screen");
        navigate("/otp-screen", { state: { email } });

        }, 1000);
      } else {
        toast.error(data.message || "Failed to resend OTP.");
      }
    } catch (error) {
      toast.error(error.message || "An error occurred while resending OTP.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth 
         PaperProps={{
        sx: { borderRadius: "13px", p: 2 } // ✅ border radius
      }}>
      <DialogTitle sx={{ textAlign: "center" }}>
        <img src={warning} style={{ width: 70, height: 70 }} alt="warning" />
      </DialogTitle>

        <CustomText
          sx={{
            ...textStyles,
            fontSize: "22px",
            fontWeight: 500,
            fontFamily: "Poppins, sans-serif",
            color: theme.palette.tertiary.main,
            mb: 2,
          }}
        >
          {t("invalidOtp.title")}
        </CustomText>

        <CustomText
          sx={{
            ...textStyles.body4,
            color: theme.palette.text.primary,
            mb: 3,
          }}
        >
{message || "Invalid OTP. Please try again."}        </CustomText>

   <Box sx={{display:"flex",justifyContent:"center",mb:2, }}>
        <CustomButton
          onClick={handleResendOtp}
          disabled={loading}
          size='medium'
          label={
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {loading && (
                <CircularProgress size={18} sx={{ color: "#fff", mr: 1 }} />
              )}
            {t("invalidOtp.cta")}
            </Box>
          }
        />
        </Box>
   
    </Dialog>
  );
};

export default InvalidOtpModal;



